module.exports = __webpack_public_path__ + "img/lincplus_04.a6c59520.png";